import axios from 'axios'

export default {
    async getAll(pageQueryId) {
        try{            
            const response = await axios.get(`CommentsHistory/${pageQueryId}`)            
            return response
        }catch (error){
            console.log('CommentsHistory api getAll error')
            throw error
        }
    }
}